import create from 'zustand';

import { View as viewContext } from '@twintag/twintag-core';
import { View } from '@esoptra/zaza-sdk';

import apiHelper from '../services/ApiService';

interface Store {
    metadata: any;
    data: any;
    dataInAllLanguages: any;

    isLoaded: boolean;
    hasError: boolean;

    getDetails: (language: string) => void;
    getFileURL: (name: string, $qid: string, FileQid: string) => any;
}

const useStore = create<Store>((set, get) => ({
    data: null,
    dataInAllLanguages: null,
    metadata: null,
    isLoaded: false,
    hasError: false,

    getDetails: async (language: string) => {
        const bodyObj = {
            action: 'getData',
            body: {
                language: language,
            },
        };

        try {
            const __data = await apiHelper.ExecuteEpsilon(bodyObj);
            set({ dataInAllLanguages: __data });
            set({ data: __data });
            set({ isLoaded: true });
        } catch (error) {
            set({ isLoaded: true });
            set({ hasError: true });
        }
    },

    getFileURL: async (name: string, $qid: string, FileQid: string) => {
        if ($qid && FileQid) {
            let view = new View(viewContext.getId());
            const sdObj = await view.object(name);
            const file: any = await sdObj.getFile($qid as string, FileQid);
            return file.fileURL;
        }
    },
}));

export default useStore;
